import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon'; // svg component

// register globally
Vue.component('svg-icon', SvgIcon);

const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('./svg', false, /\.svg$/);
requireAll(req);

// const req = require.context('./svg', false, /\.svg$/);
// const requireAll = (requireContext) => requireContext.keys().map(requireContext);
// requireAll(req);
export default {
  install(app) {
    app.component('svg-icon', SvgIcon);
  },
};
